import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

function ProtectRoute({component, forRole}) {
  // const { token: Usertoken } = useSelector((state) => state.user);
  const { user: currentUser } = useSelector((state) => state.user);
  return _.includes(forRole, _.toNumber(currentUser.role)) ? component : <Navigate to="/Login" />;
}
export default ProtectRoute;
